module.exports = __webpack_public_path__ + "img/yl-b.0fd53822.jpg";